import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { useNavigate } from '@tanstack/react-router';
import { createContactSchema, type CreateContactInput } from '@orion/contracts';
import { Button, Input } from '@orion/ui';
import { PageHeader } from '../../app/shell.js';
import { useCreateContact } from './api.js';

export function NewContactPage() {
  const navigate = useNavigate();
  const createContact = useCreateContact();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<CreateContactInput>({ resolver: zodResolver(createContactSchema), defaultValues: { customFields: {} } });

  const onSubmit = async (input: CreateContactInput) => {
    const contact = await createContact.mutateAsync(input);
    await navigate({ to: '/contacts/$contactId', params: { contactId: contact.id } });
  };

  return (
    <>
      <PageHeader title="New contact" />
      <main className="flex flex-1 justify-center p-7">
        <form onSubmit={handleSubmit(onSubmit)} noValidate className="flex w-full max-w-lg flex-col gap-4">
          <div className="grid grid-cols-2 gap-4">
            <Input label="First name" error={errors.firstName?.message} {...register('firstName')} />
            <Input label="Last name" error={errors.lastName?.message} {...register('lastName')} />
          </div>
          <Input label="Email" type="email" error={errors.email?.message} {...register('email')} />
          <Input label="Phone" error={errors.phone?.message} {...register('phone')} />
          <Input label="Job title" error={errors.jobTitle?.message} {...register('jobTitle')} />
          <Input label="Department" error={errors.department?.message} {...register('department')} />
          <div className="mt-2 flex justify-end">
            <Button type="submit" loading={isSubmitting}>
              Save contact
            </Button>
          </div>
        </form>
      </main>
    </>
  );
}
